import { makePropsProvider } from 'components/common/makePropsProvider';
import React from 'react';

export type PropsType = {
  filtersName: any;
  setFiltersName: any;
  children: React.ReactNode;
};

export const { PropsProvider: FilterNameProvider, PropsContext: FilterNameContext } = makePropsProvider<PropsType>(
  'filtersName',
  'setFiltersName',
);
